import React from 'react';
import classNames from 'classnames';
import { Highlight } from 'react-instantsearch';

import { Image } from '@uncinc/uncinc-react-kitchen-sink';

import constructImageSourcesArray from '../../../../helpers/constructImageSources';
import Card from '../../../Card';
import type { SearchAllContentProfileHit as Type } from '../../types';

const SearchAllContentProfileHit: React.FC<{ hit: Type }> = ({ hit }) => {
  const classes = classNames('SearchAllContentHit', 'SearchAllContentProfileHit');

  return (
    <Card className={classes}>
      <Card.Content>
        <Card.Link link={hit.url[0]}>
          <Card.Title title={<Highlight attribute={['first_name']} hit={hit} />} />
          <Card.Title title={<Highlight attribute={['last_name']} hit={hit} />} />
        </Card.Link>

        <div className="Card__content__metadata">
          <span className="Card__content__url body--small">
            ...{hit.url[0]}
          </span>
        </div>
      </Card.Content>

      <Card.Image
        image={(
          <Image
            src={constructImageSourcesArray(hit, '1_1')}
            alt={hit.profile_image_alt?.[0]}
            lazyload={false}
          />
        )}
      />
    </Card>
  );
};

export default SearchAllContentProfileHit;
